function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Ideal = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, React) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports["default"] = void 0;
  React = _interopRequireWildcard(React);

  function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

  function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

  function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

  var SvgIdeal = function SvgIdeal(props) {
    return /*#__PURE__*/React.createElement("div", {
      className: props.className,
      style: props.style
    }, /*#__PURE__*/React.createElement("svg", _extends({
      viewBox: "0 0 60 40",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), /*#__PURE__*/React.createElement("path", {
      d: "M60 0H0V40H60V0Z",
      fill: "#F3F6F9"
    }), /*#__PURE__*/React.createElement("g", {
      clipPath: "url(#clip0)"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M12 6.37213V33.6279C12 34.9325 13.0675 36 14.3721 36H30.6568C42.9681 36 48.3054 29.109 48.3054 19.9644C48.3054 10.8673 42.9681 4 30.6568 4H14.3721C13.0675 4 12 5.06746 12 6.37213Z",
      fill: "white"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M22.8999 10.6894V30.8288H31.6649C39.6234 30.8288 43.0749 26.3336 43.0749 19.9763C43.0749 13.8918 39.6234 9.17123 31.6649 9.17123H24.4181C23.576 9.17123 22.8999 9.85915 22.8999 10.6894Z",
      fill: "#CC0066"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M30.6568 33.8295H16.4952C15.238 33.8295 14.2179 32.8095 14.2179 31.5523V8.45962C14.2179 7.20239 15.238 6.18237 16.4952 6.18237H30.6568C44.0949 6.18237 46.0994 14.8288 46.0994 19.9763C46.0994 28.9074 40.6079 33.8295 30.6568 33.8295ZM16.4952 6.94145C15.6531 6.94145 14.977 7.61751 14.977 8.45962V31.5523C14.977 32.3944 15.6531 33.0704 16.4952 33.0704H30.6568C40.1216 33.0704 45.3403 28.4211 45.3403 19.9763C45.3403 8.63752 36.1364 6.94145 30.6568 6.94145H16.4952V6.94145Z",
      fill: "black"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M25.9837 17.2602C26.2921 17.2602 26.5767 17.3076 26.8495 17.4025C27.1223 17.4974 27.3477 17.6516 27.5493 17.8414C27.7391 18.043 27.8933 18.2921 28.0119 18.5767C28.1186 18.8732 28.1779 19.2172 28.1779 19.6205C28.1779 19.9763 28.1305 20.2965 28.0474 20.593C27.9526 20.8895 27.8221 21.1505 27.6442 21.364C27.4663 21.5775 27.2409 21.7435 26.9681 21.874C26.6953 21.9926 26.3751 22.0637 26.0074 22.0637H23.9318V17.2483H25.9837V17.2602ZM25.9125 21.1861C26.0667 21.1861 26.209 21.1623 26.3632 21.1149C26.5056 21.0675 26.636 20.9844 26.7428 20.8658C26.8495 20.7472 26.9444 20.6049 27.0156 20.4151C27.0867 20.2253 27.1223 20.0119 27.1223 19.7391C27.1223 19.5018 27.0986 19.2765 27.0511 19.0867C27.0037 18.897 26.9207 18.719 26.8139 18.5886C26.7072 18.4581 26.5649 18.3395 26.387 18.2683C26.209 18.1972 25.9955 18.1616 25.7346 18.1616H24.9755V21.1979H25.9125V21.1861Z",
      fill: "white"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M32.4596 17.2602V18.1497H29.9214V19.1816H32.258V20H29.9214V21.1742H32.5189V22.0637H28.8658V17.2483H32.4596V17.2602Z",
      fill: "white"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M36.089 17.2602L37.8918 22.0756H36.7887L36.421 21.0082H34.6182L34.2387 22.0756H33.1712L34.9859 17.2602H36.089V17.2602ZM36.1483 20.2135L35.5434 18.4463H35.5315L34.9029 20.2135H36.1483Z",
      fill: "white"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M39.6116 17.2602V21.1861H41.96V22.0756H38.556V17.2602H39.6116V17.2602Z",
      fill: "white"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18.9385 21.8859C20.1634 21.8859 21.1564 20.8929 21.1564 19.6679C21.1564 18.443 20.1634 17.45 18.9385 17.45C17.7135 17.45 16.7205 18.443 16.7205 19.6679C16.7205 20.8929 17.7135 21.8859 18.9385 21.8859Z",
      fill: "black"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M20.6108 30.8288C18.7487 30.8288 17.2543 29.3225 17.2543 27.4722V24.851C17.2543 23.9259 18.0015 23.1668 18.9385 23.1668C19.8636 23.1668 20.6227 23.914 20.6227 24.851V30.8288H20.6108Z",
      fill: "black"
    })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
      id: "clip0"
    }, /*#__PURE__*/React.createElement("rect", {
      width: 36.3054,
      height: 32,
      fill: "white",
      transform: "translate(12 4)"
    })))));
  };

  var _default = SvgIdeal;
  _exports["default"] = _default;
});